<template>
  <popup-block
    :closeModal="closeModal"
    :shown="opened"
    @close="closeModal">
    <template v-slot:popup_title>
      Геодані
    </template>

    <template v-slot:default>
      <div>
        <b>Відстань до офісу:</b> {{get_distance_in_km}}км.
      </div>

      <div v-if="has_location"
           class="mt-3">
        <small-title no_margin text="Моя локація:"/>
        <div class="mt-2">
          <iframe
            :src="`https://www.google.com/maps?q=${location.latitude},${location.longitude}&z=15&output=embed`"
            width="100%"
            height="450"
            frameborder="0"></iframe>
        </div>
      </div>
    </template>

    <template v-slot:popup_footer>
      <div class="d-flex justify-content-end">
        <default-button class="dark_button" type="button" @click="closeModal">{{$t('inputs.close')}}</default-button>
      </div>
    </template>
  </popup-block>
</template>

<script>
import PopupBlock from "./PopupBlock";
import {UNLINK_VARIABLE} from "../../helpers/variable_helpers";
import DefaultButton from "../small_components/DefaultButton.vue";
import SmallTitle from "../small_components/SmallTitle.vue";

export default {
  name: 'LocationToOfficePopup',
  components: {
    SmallTitle,
    DefaultButton,
    PopupBlock,
  },
  computed: {
    get_distance_in_km() {
      if (!this.distance) return '-';
      return (this.distance / 1000).toFixed(2)
    },
    has_location() {
      return this.location.latitude && this.location.longitude;
    }
  },
  data() {
    return {
      opened: false,
      distance: null,
      location: {
        latitude: null,
        longitude: null,
      },
    }
  },
  methods: {
    openModal(distance) {
      this.opened = true
      this.$set(this, 'distance', UNLINK_VARIABLE(distance))
      this.getMyLocation()
    },
    closeModal() {
      this.opened = false
      this.clearModalData()
      this.$emit('closed', true)
    },
    clearModalData() {
      this.distance = null
      this.location.latitude = null
      this.location.longitude = null
    },
    getMyLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getPosition, () => {});
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    },
    getPosition(position) {
      this.location.latitude = position.coords.latitude;
      this.location.longitude = position.coords.longitude;
    }
  },
}
</script>
